import { render, staticRenderFns } from "./ScheduleSuggestion.vue?vue&type=template&id=2a55da92&"
import script from "./ScheduleSuggestion.vue?vue&type=script&lang=js&"
export * from "./ScheduleSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleSuggestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports